import { Injectable } from '@angular/core';
import { AbpHttpInterceptor, MessageService } from 'abp-ng2-module';
import { HttpResponse } from '@angular/common/http';
import { Observable, switchMap, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ZeroTemplateHttpInterceptor extends AbpHttpInterceptor {
    private messageService: MessageService = new MessageService();

    protected handleErrorResponse(error: any): Observable<never> {
        if (!(error.error instanceof Blob)) {
            this.messageService.error('Server is unreachable');
            return throwError(error);
        }

        return this.configuration.blobToText(error.error).pipe(
            switchMap((json) => {
                let errorBody: any = {};
                if (json !== '' && json !== null) {
                    try {
                        errorBody = JSON.parse(json);
                    } catch {
                        errorBody = { error: { message: json, details: '' } };
                    }
                }
                const errorResponse = new HttpResponse({
                    headers: error.headers,
                    status: error.status,
                    body: errorBody,
                });

                // Check if this is a validation error - if so, skip showing popup
                // Let the component handle it in the validation sidebar
                const hasValidationErrors = errorBody?.error?.validationErrors &&
                    Array.isArray(errorBody.error.validationErrors) &&
                    errorBody.error.validationErrors.length > 0;

                if (hasValidationErrors) {
                    // Skip popup for validation errors - component will handle via sidebar
                    return throwError(error);
                }

                let ajaxResponse = this.configuration.getAbpAjaxResponseOrNull(errorResponse);

                if (ajaxResponse != null) {
                    this.configuration.handleAbpResponse(errorResponse, ajaxResponse);
                } else {
                    // Check if errorBody has ABP error format with message
                    if (errorBody?.error?.message) {
                        this.messageService.error(errorBody.error.message);
                    } else {
                        this.configuration.handleNonAbpErrorResponse(errorResponse);
                    }
                }

                return throwError(error);
            })
        );
    }
}
